<template>
    <el-button v-if="this.isTowerCo() && this.isManager() && this.canAccess('project|maintenance|finance')" icon="fa fa-trash-alt" @click="deleteEntry()" size="small" type="danger" circle></el-button>
</template>

  <script>
  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],
    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'equiptable'
      }
    },


    methods: {

      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/assets', this.rowData.category +
         ' / ' + this.rowData.type +
          (this.rowData.subType ? '/ ' + this.rowData.subType : '') +
           ' ' + (this.rowData.name ? ' / ' + this.rowData.name : ''),
           this.onDelete)
      },

      onDelete (response) {
        this.$events.fire(this.tableRef + '-refresh-table')
        this.$emit('update-stats')
      }

    }

  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>



// WEBPACK FOOTER //
// EquipControls.vue?361f7046